export default __webpack_public_path__ + "static/media/2.602dc8a1.jpg";